import { createAppSelector, selectCurrentUserId } from "./base";

import type { RootState } from "store/index";

const EMPTY_PREVIEW: Record<string, string> = {};

export const selectPageGroupPreviewsByPageId = (state: RootState, pageId: string) =>
  state.interim.pageGroupPreviews[pageId] ?? EMPTY_PREVIEW;

export const selectPreviewUserIdsForPageGroup = createAppSelector(
  [
    (state: RootState, pageId: string) => selectPageGroupPreviewsByPageId(state, pageId),
    (_state: RootState, _pageId: string, pageGroupId: string) => pageGroupId,
  ],
  (preview, pageGroupId) => {
    const userIds: string[] = [];
    for (const [userId, previewGroupId] of Object.entries(preview)) {
      if (previewGroupId === pageGroupId) {
        userIds.push(userId);
      }
    }

    return userIds;
  },
);

export const selectCurrentUserPreviewGroupId = (state: RootState, pageId: string) => {
  const currentUserId = selectCurrentUserId(state);
  if (!currentUserId) {
    return null;
  }

  return selectPageGroupPreviewsByPageId(state, pageId)[currentUserId] ?? null;
};
